import { useQuery } from '@tanstack/react-query';
import { ModalDialog } from '@/shared/ui/ModalDialog';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import type { SelectOption } from '@/shared/ui/selectTypes';
import { fetchNotification, notificationToValues, type NotificationDetails } from './api';
import { NotificationModal } from './NotificationModal';

type Props = {
  id: number;
  /** Fields the list already has; recipients and geography come from `/notification/view/`. */
  row: Pick<NotificationDetails, 'category_id' | 'message' | 'send_time'>;
  categories: SelectOption[];
  onClose: () => void;
};

/** Loads the notification details (recipients, geography) before showing the edit form. */
export const NotificationEditModal = ({ id, row, categories, onClose }: Props) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['notification', id],
    queryFn: () => fetchNotification(id),
    gcTime: 0,
  });

  if (!data) {
    return (
      <ModalDialog title="Обновить уведомление" onClose={onClose}>
        <QueryStatus isLoading={isLoading} error={error} errorText="Ошибка загрузки уведомления" />
      </ModalDialog>
    );
  }

  return (
    <NotificationModal
      id={id}
      initial={notificationToValues({ ...data, ...row })}
      categories={categories}
      onClose={onClose}
    />
  );
};
